import type { MediaImageInterface } from '@hypercodestudio/basler-components';

import type { LightingAdvisorInput } from '~/types/lightingAdvisor';

export interface LightingAdvisorSelectOption {
  label: string;
  value: string;
  image?: MediaImageInterface;
}

/** Maps tools API `{ text, value }` inputs to PrimeVue / UI `{ label, value }`. */
export function mapQuestionInputsToSelectOptions(
  inputs: LightingAdvisorInput[] | null | undefined,
  images: Readonly<Partial<Record<string, MediaImageInterface>>> = {}
): LightingAdvisorSelectOption[] {
  if (!Array.isArray(inputs)) {
    return [];
  }
  const options: LightingAdvisorSelectOption[] = [];
  for (const input of inputs) {
    if (input == null || typeof input !== 'object') {
      continue;
    }
    const value = String(input.value ?? '').trim();
    if (!value) {
      continue;
    }
    const text = String(input.text ?? '').trim();
    const label = text || value;
    const configuredImage = images[value];
    const image = configuredImage
      ? {
          ...configuredImage,
          alt: configuredImage.alt || label
        }
      : undefined;
    options.push({
      label,
      value,
      ...(image ? { image } : {})
    });
  }
  return options;
}

export function normalizeQuestionInputs(raw: unknown): LightingAdvisorInput[] {
  return mapQuestionInputsToSelectOptions(
    Array.isArray(raw) ? (raw as LightingAdvisorInput[]) : []
  ).map((option) => ({
    text: option.label,
    value: option.value
  }));
}
